// material
import { Box, BoxProps } from '@mui/material';

const Logo = ({ sx }: BoxProps) => (
  <Box sx={{ width: 40, height: 40, ...sx }} component="img" src="/static/logo/logo.svg" />
);

export default Logo;
